// @ts-nocheck
import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Unstable_Grid2';
import { DatePicker } from '@mui/x-date-pickers';
import { useFormik } from 'formik';
import moment from 'moment';
import { FC, useEffect, useMemo } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { RouterLink } from 'src/components/router-link';
import { paths } from 'src/paths';
import { getAllDisciplineTypeAction } from 'src/redux/actions/disciplineTypeAction';
import {
  createFacilityStay,
  getFacility,
  resetEditFacilityStay,
  resetFacilityListDropdown,
  resetFacilityStay,
  updateFacilityStay,
} from 'src/redux/actions/facilityActions';
import { convertDateToSelectedTimeZone } from 'src/utils/convertDateToSelectedTimeZone';
import * as Yup from 'yup';
import SimpleSnackbar from './sub-components/snackBar';
import useCurrentUser from 'src/hooks/use-current-user';

type Props = {
  patientData: any;
  patientError: string;
  setPatientError: any;
};

function getCurrentDateUTCWithoutTime(date: any) {
  // Get the date components
  const utcDateFormate = moment(date).format('YYYY-MM-DD');
  // Construct the UTC date string with time portion set to 00:00:00.000Z
  const utcDateString = `${utcDateFormate}T00:00:00.000Z`;

  return utcDateString;
}

export const EditFacilityStayForm: FC<any> = (props: Props) => {
  const { patientError, setPatientError, patientData } = props;
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { patientDetails, patients } = paths;
  const [providerId] = useCurrentUser(['providerId']);
  const createfacilityStays = useSelector((state: any) => state?.createFacilityStayReducer);
  const editfacilityStays = useSelector((state: any) => state?.updateFacilityStayReducer);
  const disciplineTypeOption = useSelector(
    (state: any) => state.getDisciplineTypeReducer?.response
  );
  const facilitiesResponse = useSelector(
    (state: any) => state?.getAllFaciltiesReducer?.response?.data?.data?.content
  );

  const facilityResp = useSelector((state: any) => state.getAllFaciltiesReducer);

  useEffect(() => {
    dispatch(
      getAllDisciplineTypeAction({
        providerId,
      })
    );
  }, []);

  const payload = useMemo(() => {
    return {
      source: 'ENTERPRISE',
    };
  }, []);

  useEffect(() => {
    setPatientError('');
  }, []);

  const validationSchema = Yup.object().shape({
    facilityName: Yup.string().required('Please enter a valid Facility name'),
    residence: Yup.string().required('Please choose a valid Residence'),
    startDate: Yup.date().required('Please enter a valid Start Date'),
    endDate: Yup.string().when('startDate', (startDate: any) => {
      const startingDate = startDate?.length > 0 && startDate[0];
      if (startingDate === '') return Yup.string().required('Please enter a valid End Date');
      else {
        const date1 = new Date(startingDate);
        return Yup.string()
          .required('Please enter a valid End Date')
          .test('date', 'End Date should be after Start Date', (value: any) => {
            const date2 = new Date(value);
            if (date1 <= date2) return true;
            else return false;
          });
      }
    }),
  });
  const startDateWithoutTimeZone = location?.state?.data?.startDate?.split('T')?.at(0);
  const endDateWithoutTimeZone = location?.state?.data?.dischargeDate?.split('T')?.at(0);

  const formik = useFormik({
    initialValues: {
      facilityName: location.state?.data?.facilityName || '',
      residence: location.state?.data?.placeOfResidence || '',
      startDate:
        location?.state?.action === 'Edit'
          ? location?.state?.data?.startDate
            ? new Date(
                new Date(startDateWithoutTimeZone).valueOf() +
                  new Date(startDateWithoutTimeZone).getTimezoneOffset() * 60 * 1000
              )
            : null
          : null,
      endDate:
        location?.state?.action === 'Edit'
          ? location?.state?.data?.dischargeDate
            ? new Date(
                new Date(endDateWithoutTimeZone).valueOf() +
                  new Date(endDateWithoutTimeZone).getTimezoneOffset() * 60 * 1000
              )
            : null
          : null,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const requestBody = {
        facilityName: values.facilityName,
        placeOfResidence: values.residence,
        startDate: getCurrentDateUTCWithoutTime(values.startDate),
        dischargeDate: getCurrentDateUTCWithoutTime(values.endDate),
      };
      if (location?.state?.action === 'Edit') {
        dispatch(
          updateFacilityStay({
            uuid: location.state?.data?.uuid,
            data: requestBody,
          })
        );
      } else {
        dispatch(
          createFacilityStay({
            uuid: patientData?.uuid,
            data: requestBody,
          })
        );
      }
    },
  });

  useEffect(() => {
    if (!createfacilityStays?.useFacilityStayCreated && createfacilityStays?.response === null)
      return;
    if (!createfacilityStays?.useFacilityStayCreated && createfacilityStays?.response !== null) {
      setPatientError(
        createfacilityStays?.response?.data?.message || createfacilityStays?.response?.message
      );
      return;
    }
    if (createfacilityStays?.useFacilityStayCreated) setPatientError('');
    setTimeout(() => {
      dispatch(resetFacilityStay());
      navigate(`${patients}/${patientDetails}`);
    }, 3000);
  }, [createfacilityStays]);

  useEffect(() => {
    if (!editfacilityStays?.useFacilityStayUpdated && editfacilityStays?.response === null) return;
    if (!editfacilityStays?.useFacilityStayUpdated && editfacilityStays?.response !== null) {
      setPatientError(
        editfacilityStays?.response?.data?.message || editfacilityStays?.response?.message
      );
      return;
    }
    if (editfacilityStays?.useFacilityStayUpdated) setPatientError('');
    setTimeout(() => {
      dispatch(resetEditFacilityStay());
      navigate(`${patients}/${patientDetails}`);
    }, 1000);
  }, [editfacilityStays]);

  useEffect(() => {
    dispatch(resetFacilityListDropdown());
    dispatch(
      getFacility({
        source: 'ENTERPRISE',
        page: 0,
        status: true,
      })
    );
  }, []);

  const handleMenuItemClick = (item: any) => {
    formik.setFieldValue('facilityName', item.name);
  };

  return (
    <Box sx={{ p: 3 }}>
      <form onSubmit={formik.handleSubmit}>
        <Grid
          container
          spacing={3}
        >
          <Grid
            xs={12}
            lg={6}
          >
            <FormControl
              error={formik.touched.facilityName && Boolean(formik.errors.facilityName)}
              fullWidth
            >
              <InputLabel
                error={formik.touched.facilityName && Boolean(formik.errors.facilityName)}
                id="demo-simple-select-label"
              >
                {' '}
                Facility Name
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                error={formik.touched.facilityName && Boolean(formik.errors.facilityName)}
                fullWidth
                displayEmpty
                label="Facility Name"
                placeholder="Select Facility Name"
                value={formik.values.facilityName}
                renderValue={(value) => {
                  if (value === '') return;
                  else return <div>{value as any}</div>;
                }}
              >
                <InfiniteScroll
                  dataLength={facilityResp?.totalFacility?.length}
                  next={() => {
                    dispatch(
                      getFacility({
                        source: 'ENTERPRISE',
                        page: facilityResp?.pageNumber,
                        status: true,
                      })
                    );
                  }}
                  hasMore={
                    facilityResp?.response?.data?.data?.totalElements !==
                    facilityResp?.totalFacility?.length
                  }
                  loader={
                    <p style={{ textAlign: 'center' }}>
                      <CircularProgress />
                    </p>
                  }
                  height={350}
                  style={{
                    overflow: 'scroll',
                    height: 300,
                  }}
                  // endMessage={
                  //   <p style={{ textAlign: 'center' }}>
                  //     <b>No more facilities are available</b>
                  //   </p>
                  // }
                >
                  {facilityResp?.totalFacility?.map((option: any) => (
                    <MenuItem
                      key={option.uuid}
                      value={option.name}
                      onClick={() => handleMenuItemClick(option)}
                    >
                      {option.name}
                    </MenuItem>
                  ))}
                </InfiniteScroll>
              </Select>
              {formik.touched.facilityName && formik.errors.facilityName && (
                <Typography
                  padding={'0px 20px'}
                  color={'red'}
                  variant="caption"
                >
                  
                  {formik.errors.facilityName}
                </Typography>
              )}
            </FormControl>
          </Grid>

          <Grid
            xs={12}
            lg={6} // @ts-nocheck
          >
            <TextField
              error={!!(formik.touched.residence && formik.errors.residence)}
              fullWidth
              helperText={formik.touched.residence && (formik.errors.residence as any)}
              label="Residence"
              name="residence"
              placeholder="Select residence"
              onBlur={formik.handleBlur}
              onChange={(e) => {
                const trimmedValue = e.target.value;

                formik.setFieldValue('residence', trimmedValue);
              }}
              value={formik.values.residence}
              select
            >
              {disciplineTypeOption?.map((option: any) => (
                <MenuItem
                  key={option.key}
                  value={option.key}
                >
                  {option.displayName}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid
            xs={12}
            lg={6}
          >
            <DatePicker
              onChange={(newDate) => formik.setFieldValue('startDate', newDate)}
              value={formik.values.startDate}
              format="MM dd, yyyy"
              disableFuture
              sx={{
                width: '100%',
                border: formik.touched.startDate && formik.errors.startDate ? '2px solid red' : '',
                borderRadius: formik.touched.startDate && formik.errors.startDate ? '10px' : '',
              }}
              error={formik.errors.startDate}
              helperText={formik.touched.startDate && formik.errors.startDate}
              label="Start Date"
            />
            {formik.touched.startDate && formik.errors.startDate && (
              <Typography
                padding={'0px 20px'}
                color={'red'}
                variant="caption"
              >
                {formik.errors.startDate}
              </Typography>
            )}
          </Grid>
          <Grid
            xs={12}
            lg={6}
          >
            <DatePicker
              onChange={(newDate) => formik.setFieldValue('endDate', newDate)}
              label="End Date"
              value={formik.values.endDate}
              format="MM dd, yyyy"
              sx={{
                width: '100%',
                border: formik.touched.endDate && formik.errors.endDate ? '2px solid red' : '',
                borderRadius: formik.touched.endDate && formik.errors.endDate ? '10px' : '',
              }}
            />
            {formik.touched.endDate && formik.errors.endDate && (
              <Typography
                padding={'0px 16px'}
                color={'red'}
                variant="caption"
              >
                {formik.errors.endDate}
              </Typography>
            )}
          </Grid>
        </Grid>
        {(!createfacilityStays?.useFacilityStayCreated ||
          !editfacilityStays?.useFacilityStayUpdated) && (
          <Typography
            padding={'20px 0px'}
            variant="subtitle1"
            color="red"
          >
            {patientError}
          </Typography>
        )}
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            alignContent: 'flex-end',
          }}
          mt={4}
        >
          {(createfacilityStays?.useFacilityStayCreated ||
            editfacilityStays?.useFacilityStayUpdated) && (
            <SimpleSnackbar
              message={
                createfacilityStays?.response?.data?.message ||
                editfacilityStays?.response?.data?.message
              }
            />
          )}
          <Box sx={{ flexGrow: 1 }} />
          <Button
            color="inherit"
            component={RouterLink}
            disabled={formik.isSubmitting}
            onClick={() => navigate(-1)}
          >
            Cancel
          </Button>
          <Button
            sx={{ ml: 1 }}
            variant="contained"
            disabled={
              createfacilityStays?.loading ||
              editfacilityStays?.loading ||
              createfacilityStays?.useFacilityStayCreated ||
              editfacilityStays?.useFacilityStayUpdated
            }
            type="submit"
          >
            Save
          </Button>
        </Box>
      </form>
    </Box>
  );
};
